var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-highly',{ref:"dialog",staticClass:"dialog-highly-permission",attrs:{"title":_vm.title,"desc":_vm.desc,"count-down":"10","sure-label":"立即跳转","tips":"${countDown} 秒后跳转到用户中心","sure-method":_vm.sureMethod}})}
var staticRenderFns = []

export { render, staticRenderFns }